import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";

import { setCartOffers } from "state/cart-slice";
import { offersState } from "state/offers-slice";
import Offer from "types/Offer";

const useCookieCart = () => {
  const [cookies] = useCookies();
  const dispatch = useDispatch();
  const offers = useSelector(offersState);

  useEffect(() => {
    const storedOfferNames = cookies.CART;

    const storedOffers = offers.offersList.filter((offer: Offer) => storedOfferNames?.includes(offer.name));

    dispatch(setCartOffers({ offers: storedOffers }));
  }, [dispatch, cookies.CART, offers.offersList]);
};

export default useCookieCart;
